// Renders a "Home / ... / Current" trail. `trail` is an array of
// { label, href } — the last entry should omit `href` (current page).
export function renderBreadcrumb(trail) {
  const crumbs = [`<a href="/">Home</a>`];
  trail.forEach((item) => {
    crumbs.push(`<span class="breadcrumb__sep" aria-hidden="true">/</span>`);
    crumbs.push(
      item.href
        ? `<a href="${item.href}">${item.label}</a>`
        : `<span aria-current="page">${item.label}</span>`
    );
  });
  // The bar itself spans the full width (for the sticky background/border);
  // its content sits in `.container` so it lines up with the logo above it.
  return `
    <nav class="breadcrumb" aria-label="Breadcrumb">
      <div class="container breadcrumb__inner">${crumbs.join("")}</div>
    </nav>
  `;
}
